export const MOBILE_SDK_TESTS_PAGE_HEADER_LABELS = {
	PAGE_TITLE: 'All tests',
	OLDER_TESTS_LINK: 'See older Tests',
	SHOW_ONLY_LATEST_TESTS: 'Show only the last report per test',
	FILTERS_SECTION_ARIA_LABEL: 'Mobile SDK tests filters'
} as const;
